/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { stringify as queryify } from 'qs';

function QueryLink(query: Object) {
  const queryString = queryify(query);

  return (props: Object) => (
    <Link
      {...props}
      to={{ search: `?${queryString}` }}
    />
  );
}

export default QueryLink;
